import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_E_DETAILING_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const EDetailingReport = lazy(() => import('../../../screens/EDetailingReport')
  .then(module => ({default: module.EDetailingReport})));

const EDetailingReportNavigation = [
  {
    path: ROUTE_E_DETAILING_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EDetailingReport />
      </Suspense>
    ),
  },
];

export default EDetailingReportNavigation;
